import { routeMap, histories, comps, first } from '../router/index';

export default {
  components: {
    ...comps
  },
  data() {
    histories.push({ name: first });
    return {
      histories,
      active: first
    };
  },
  provide() {
    return {
      router: {
        back: this.back,
        goto: this.goto,
        toHome: this.home,
        getRoute: this.getRoute
      }
    };
  },
  computed: {
    currentRoute() {
      const last = this.histories[this.histories.length - 1];
      return this.getRoute(last.name);
    }
  },
  methods: {
    getRoute(key) {
      return routeMap[key];
    },
    goto(name, params) {
      if (histories[histories.length - 1].name === name) return;
      const out = histories.length - 10;
      if (out > 0) histories.splice(1, out);
      histories.push({ name, params });
    },
    back() {
      if (histories.length === 1) {
        this.home();
      } else {
        histories.pop();
      }
    },
    home() {
      this.histories.splice(0, Infinity, { name: first });
      this.active = first;
    }
  }
};
